/* eslint-disable no-unused-vars */
import * as React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';

import logoLight from '../assets/images/static/logo-light.png';
import logoDark from '../assets/images/static/logo-dark.png';

function AppAppBar({ mode, toggleColorMode }) {
  const [open, setOpen] = React.useState(false);
  const [urlPlatform] = React.useState('https://app.phorm.com.br/');

  const logoStyle = {
    width: '130px',
    height: 'auto',
    cursor: 'pointer',
    padding: '10px'
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const scrollToSection = (sectionId) => {
    const sectionElement = document.getElementById(sectionId);
    const offset = 128;
    if (sectionElement) {
      const targetScroll = sectionElement.offsetTop - offset;
      sectionElement.scrollIntoView({ behavior: 'smooth' });
      window.scrollTo({
        top: targetScroll,
        behavior: 'smooth'
      });
      setOpen(false);
    }
  };

  // Adicionamos a prop 'aoClicar' (ou 'onClick')
  function BotaoEspecial({ texto, aoClicar }) {
    const [isHovered, setIsHovered] = React.useState(false)

    const estiloBotao = {
      color: isHovered ? '#A5E13B' : '#ffffffa6', // Muda a cor do texto
      padding: '5px 10px',
      transition: 'all 0.3s ease',           // Descomentei para ficar suave!
      cursor: 'pointer',
    };

    return (
      <MenuItem
        style={estiloBotao}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => scrollToSection(aoClicar)} // <-- Aqui a mágica acontece!
      >
        <Typography>
          {texto}
        </Typography>
      </MenuItem>
    );
  }

  return (
    <div>
      <AppBar
        position="fixed"
        sx={{
          boxShadow: 0,
          bgcolor: 'transparent',
          backgroundImage: 'none',
          mt: 2
        }}>
        <Container maxWidth="lg">
          <Toolbar
            variant="regular"
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexShrink: 0,
              borderRadius: '50px',
              bgcolor: '#0A0B0E',
              backdropFilter: 'blur(24px)',
              maxHeight: 80,
              border: '1px solid',
              borderColor: '#ffffff33',
              boxShadow:
                theme.palette.mode === 'light'
                  ? `0 0 1px rgba(85, 166, 246, 0.1), 1px 1.5px 2px -1px rgba(85, 166, 246, 0.15), 4px 4px 12px -2.5px rgba(85, 166, 246, 0.15)`
                  : '0 0 1px rgba(2, 31, 59, 0.7), 1px 1.5px 2px -1px rgba(2, 31, 59, 0.65), 4px 4px 12px -2.5px rgba(2, 31, 59, 0.65)'
            })}>
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
                ml: '',
                px: 0
              }}>
              <img
                src={mode === 'light' ? logoDark : logoLight}
                style={logoStyle}
                alt="Phorm Fitness"
                onClick={() => scrollToSection('AboutPlatform')}
              />
              <Box sx={{ display: { xs: 'none', md: 'flex' }, ml: 2 }}>
                <BotaoEspecial
                  texto="Conheça a Phorm"
                  aoClicar={'AboutPlatform'}
                />
                <BotaoEspecial
                  texto="Planos"
                  aoClicar={'OurPlans'}
                />
                <BotaoEspecial
                  texto="Quem somos"
                  aoClicar={'AboutUS'}
                />
                <BotaoEspecial
                  texto="Empresas & Parceiros"
                  aoClicar={'CompanyContact'}
                />
                <BotaoEspecial
                  texto="FAQ"
                  aoClicar={'faq'}
                />
              </Box>
            </Box>

            <Box
              sx={{
                display: { xs: 'none', md: 'flex' },
                gap: 0.5,
                alignItems: 'center'
              }}>
              <Button
                style={{ backgroundColor: '#A5E13B', fontWeight: 500, color: '#131313', borderRadius: 50, width: 120 }}
                variant="outlined"
                size="small"
                component="a"
                sx={{ ml: 2, height: 100 }}
                href={'https://app.phorm.com.br/'}
                target="_blank">
                Acessar
              </Button>
            </Box>

            <Box sx={{ display: { sm: '', md: 'none' } }}>
              <Button
                variant="text"
                color="primary"
                aria-label="menu"
                onClick={toggleDrawer(true)}
                sx={{ minWidth: '30px', p: '4px' }}>
                <MenuIcon />
              </Button>

              <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                <Box
                  sx={{
                    minWidth: '60dvw',
                    p: 2,
                    backgroundColor: '#2e2e2e',
                    flexGrow: 1,
                  }}>
                  <BotaoEspecial
                    texto="Conheça a Phorm"
                    aoClicar={'AboutPlatform'}
                  />

                  <BotaoEspecial
                    texto="Planos"
                    aoClicar={'OurPlans'}
                  />
                  <BotaoEspecial
                    texto="Quem somos"
                    aoClicar={'PartnersContact'}
                  />
                  <BotaoEspecial
                    texto="Empresas & Parceiros"
                    aoClicar={'CompanyContact'}
                  />
                  <BotaoEspecial
                    texto="FAQ"
                    aoClicar={'faq'}
                  />
                  <Divider />

                  <MenuItem>
                    <Button
                      color="primary"
                      variant="outlined"
                      component="a"
                      href={urlPlatform}
                      target="_blank"
                      sx={{ width: '100%' }}
                      style={{ backgroundColor: '#A5E13B', fontWeight: 500, color: '#131313', borderRadius: 50 }}

                    >
                      <PersonIcon sx={{ mr: 1 }} />
                      Acessar
                    </Button>
                  </MenuItem>
                </Box>
              </Drawer>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
}

AppAppBar.propTypes = {
  mode: PropTypes.oneOf(['dark', 'light']).isRequired,
  toggleColorMode: PropTypes.func.isRequired
};

export default AppAppBar;
